<template>
<div id="contents">

  <div id="recruit" class="page_contents">

    <div id="recruit_contents">
      <div id="recruit_index">
        <div class="page_header">
          <h1 class="page_header_title">
            <img src="../assets/img/recruit/title.png" width="318" alt="RECRUIT" />
            <span>採用情報</span>
          </h1><!-- .top_sec_title -->
        </div><!-- .page_header -->

        <div id="recruit_index_main" class="page_main_contents">
          <!-- <div class="recruit_wrapper section01 recruit_banner_warp">
            <p class="recruit_banner">
              <a href="https://job.mynavi.jp/26/pc/search/corp93057/is.html" target="_blank">
                <img src="../assets/img/recruit/2025/top/mynavi2026banner.jpg" alt="マイナビ2026" width="70%" />
              </a>
            </p>
          </div> -->

          <div class="recruit_wrapper section01">
            <div class="recruit_box js-click_box">
              <h3 class="recruit_box_title">
                <p class="ttl">新卒採用</p>
                <p class="recruit_box_link"><a href="https://www.tv-asahipro-recruit.com/" target="_blank">リクルートサイトへ</a></p>
              </h3>
              <div class="recruit_box_inner">
                <p>2028年度新卒採用情報はコチラ</p>
              </div><!-- .recruit_box_inner -->
            </div><!-- .recruit_box -->

            <div class="recruit_box js-click_box_no_window"><!-- .js-click_box_no_window --><!-- style="cursor: auto;" -->
              <h3 class="recruit_box_title">
                <p class="ttl">経験者採用</p>
                <p class="recruit_box_link"><router-link v-bind:to="{name: 'recruit_requirements'}">応募要項ページへ</router-link></p>
              </h3>
              <div class="recruit_box_inner">
                <p>2026年度入社<br />ディレクター／プロデューサーを<br />募集しています。</p>
              </div><!-- .recruit_box_inner -->
            </div><!-- .recruit_box -->
          </div><!-- .recruit_wrapper -->


          <div class="recruit_wrapper section01">
            <div class="recruit_box js-click_box">
              <h3 class="recruit_box_title">
                <p class="multiple">テレビ朝日映像<br />クリエイターズバンク</p>
                <p class="recruit_box_link"><router-link v-bind:to="{name: 'creator_bank_contact'}">登録サイトへ</router-link></p>
              </h3>
              <div class="recruit_box_inner" style="height: 265px;">
                <p>映像制作のお仕事をして頂ける<br />フリークリエイターを<br />募集しています。</p>
              </div><!-- .recruit_box_inner -->
            </div><!-- .recruit_box -->

            <div class="recruit_box js-click_box">
              <h3 class="recruit_box_title">
                <p class="viviap_ttl">グループ会社採用</p>
                <p class="recruit_box_link"><a href="http://www.viviap.co.jp/" target="_blank">びびあっぷサイトへ</a></p>
              </h3>
              <div class="recruit_box_inner viviap">
                <p class="logo"><a href="http://www.viviap.co.jp/" class="hover" target="_blank"><img src="../assets/img/recruit/viviap_logo.png" width="230" alt="株式会社びびあっぷ" /></a></p>
                <p>【キャリア採用・経験者募集】<br />報道・情報・バラエティ番組、Web動画等制作で<br />活躍いただく映像コンテンツ制作ディレクター<br />およびディレクター候補<br />ご応募お待ちしております。</p>
              </div><!-- .recruit_box_inner -->
            </div><!-- .recruit_box -->
          </div><!-- .recruit_wrapper -->


        </div><!-- #recruit_index_main -->

      </div><!-- #recruit_index -->
    </div><!-- #recruit_contents -->
  </div><!-- #recruit -->



</div><!-- #contents -->
</template>

<script>
export default {
  name: 'recruit_index',
  mounted () {
    const ts = this
    setTimeout(function(){
      ts.$emit('page_fade')
    },ts.$parent.page_load_time)
    $('.js-click_box').click(function(){
      var link = $(this).find('a').attr('href');
      console.log(link);
      window.open(link);
      return false;
    });
    $('.js-click_box_no_window').click(function(){
      var link = $(this).find('a').attr('href');
      console.log(link);
      window.location.replace(link);
      return false;
    });
  }
}
</script>

<style scoped>
</style>

<style lang="sass">
  #apology_link
    margin: 0 0 30px
    a
      font-weight: bold
      color: #000
      transition: .3s all
      &:hover
        color: #df4661
        text-decoration: none
</style>



// WEBPACK FOOTER //
// src/components/recruit_index.vue